import { ActionTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { FiltersSeismograms, FiltersState } from '@/models/states/filters-state.model';

export const actions: ActionTree<FiltersState, RootState> = {
  updateFilters({ commit }, payload: FiltersSeismograms): any {
    commit('onUpdateFilters', payload);
  },
};
